var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pcViews"}},[_c('main-tar-bar'),_c('router-view'),_c('Footer'),_c('div',{staticClass:"servi-btn",on:{"click":_vm.openService}},[_c('i',{staticClass:"el-icon-service",staticStyle:{"color":"#409EFF","font-weight":"bold","font-size":"30px"}})]),_c('el-backtop',{attrs:{"bottom":200}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }